import { ImageDoctors } from 'components/icons';
import { Button } from 'components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useGetPublicTranslation } from 'api/hooks';
import { useTranslation } from 'react-i18next';

const containerStyle = {
  backgroundImage: `url(/images/yellow.png)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};
export default function CTAContainer({ onQuestionnaireClick, withImage }) {
  const { translation: title } = useGetPublicTranslation({ resourceKey: 'Landing', key: 'CTATitle' });
  const { t } = useTranslation();

  return (
    <div className="flex rounded-xl bg-vp-light-yellow flex-col items-center" style={containerStyle}>
      <div
        className={classNames(
          'flex flex-col rounded-xl md:flex-row md:items-center md:justify-center space-y-8 md:space-y-0',
          {
            'py-24': !withImage,
            'pt-16': withImage,
          },
        )}
      >
        <span className="md:px-8 px-2.5 text-3xl font-extrabold flex-1">{title?.text}</span>
        <div className="md:px-8 px-2.5 flex justify-stretch md:justify-end flex-1 w-full">
          <Button radius="xl" color="defaultBorderless" className="w-full md:w-min" onClick={onQuestionnaireClick}>
            {t('btn.questionnaire-complete')}
          </Button>
        </div>
      </div>
      {withImage && <ImageDoctors className="w-full md:w-[673px]" />}
    </div>
  );
}
CTAContainer.propTypes = {
  onQuestionnaireClick: PropTypes.func,
  withImage: PropTypes.bool,
};

CTAContainer.defaultProps = {
  onQuestionnaireClick: _.noop,
  withImage: false,
};
